/**
 * @desc 导入运营调整信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/srm/procurementOrder/importOperationAdjustment`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
